import React from 'react';
import { cn } from '../../lib/utils';

// iOS-style segmented control for mutually-exclusive choices (condition type,
// operator, notification level, All/Any). The web analog of mirfa-home's
// <Segmented>. options: [{ label, value }].
const SegmentedControl = React.forwardRef(
  ({ className, options = [], value, onChange, ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="tablist"
        className={cn('inline-flex w-full gap-1 rounded-xl bg-muted/60 p-1', className)}
        {...props}
      >
        {options.map((opt) => {
          const selected = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => onChange?.(opt.value)}
              className={cn(
                'flex-1 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                selected
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  }
);
SegmentedControl.displayName = 'SegmentedControl';

export { SegmentedControl };
